import moment from 'moment';
import { getAppInstance } from '/@/store/session/selectors';

export const getForecast = (state) => state.weather.forecast;
export const getHourlyForecasts = (state) => state.weather.hourlyForecasts;
/**
 * @typedef {'R' | 'O' | 'Y' | 'G'} FrostRiskEnum
 * @returns {Record<string, {'7d': FrostRiskEnum, '14d': FrostRiskEnum, id: string}>} */
export const getLowGDUsRisks = (state) => {
    return state.weather.lowGDUsRisk;
};
export const getWeatherLoading = (state) => state.weather.loading;

export const getWeatherLastFetch = (fieldId, state) => {
    const currentWeather = getCurrentWeather(state);
    if (Object.keys(currentWeather).length === 0) return false;
    if (!currentWeather[`${fieldId}`]) return false;
    return state.weather.current[`${fieldId}`].lastFetch;
};

export const shouldFetchWeather = (fieldId, state) => {
    const lastFetch = getWeatherLastFetch(fieldId, state);
    if (!lastFetch || moment().subtract(3, 'minutes').isAfter(lastFetch)) return true;
    return false;
};

export const getCurrentWeather = (state) => {
    return state.weather.current || undefined;
};

export const getField = (state) => {
    return state.weather.field || undefined;
};

export const getWeatherFeatureEnabled = (state) => {
    return getAppInstance(state).enableWeatherFeature;
};
